<template>
  <div>
    <strong v-if="customer.CustomerHasCmdmFailed && customer.PoId === '-1'">{{
      i18n.t('/Customer/Customer Adding Customer CMDM Failed Message')
    }}</strong>
    <strong v-if="customer.CustomerHasCmdmFailed && customer.PoId !== '-1'">{{
      i18n.t('/Customer/Customer Updating Customer CMDM Failed Message')
    }}</strong>

    <dl class="customer-details">
      <dt>{{ i18n.t('/Customer/Create New Customer Form/New Customer Gender Label') }}:</dt>
      <dd>{{ gender }}</dd>
      <dt>{{ i18n.t('/Customer/Create New Customer Form/New Customer First Name Label') }}:</dt>
      <dd>{{ customer.CustomerFirstName || '-' }}</dd>
      <dt>{{ i18n.t('/Customer/Create New Customer Form/New Customer Middle Name Label') }}:</dt>
      <dd>{{ customer.CustomerMiddleName || '-' }}</dd>
      <dt>{{ i18n.t('/Customer/Create New Customer Form/New Customer Initials Label') }}:</dt>
      <dd>{{ customer.CustomerInitials || '-' }}</dd>
      <dt>{{ i18n.t('/Customer/Create New Customer Form/New Customer Family Name Label') }}:</dt>
      <dd>{{ customer.CustomerFamilyName || '-' }}</dd>
      <dt>{{ i18n.t('/Customer/Create New Customer Form/New Customer Email Label') }}:</dt>
      <dd data-qa="email">{{ customer.CustomerEmail || '-' }}</dd>
      <dt>{{ i18n.t('/Customer/Create New Customer Form/New Customer Telephone Label') }}:</dt>
      <dd>{{ customerPhone }}</dd>
      <dt>{{ i18n.t('/Customer/Customer Address Label') }}:</dt>
      <dd>{{ customer.CustomerAddress || customer.CustomerStreet || '-' }}</dd>
      <dt>{{ i18n.t('/Customer/Create New Customer Form/New Customer Zipcode Label') }}:</dt>
      <dd data-qa="zipcode">{{ customer.CustomerZipCode || '-' }}</dd>
      <dt>{{ i18n.t('/Customer/Create New Customer Form/New Customer City Label') }}:</dt>
      <dd>{{ customer.CustomerCity || '-' }}</dd>
      <dt>{{ i18n.t('/Customer/Edit Customer Form/Customer Edit Country Label') }}:</dt>
      <dd>{{ countryList[customer.CustomerCountryCode] || '-' }}</dd>
      <template v-if="!!customer.PoId && customer.PoId !== '-1' && customer.PoId !== '0'">
        <dt>{{ i18n.t('/Customer/poid') }}:</dt>
        <dd>{{ customer.PoId }}</dd>
      </template>
      <template
        v-if="
          !!customer.CustomerMagicNumber &&
          customer.CustomerMagicNumber !== '-1' &&
          customer.CustomerMagicNumber !== '0'
        "
      >
        <dt>{{ i18n.t('/Customer/magicnumber') }}:</dt>
        <dd>{{ customer.CustomerMagicNumber }}</dd>
      </template>
    </dl>
  </div>
</template>

<script>
import CountryHelper from '@/helpers/CountryHelper'

export default {
  props: {
    customer: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      countryList: CountryHelper.countryList(),
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  computed: {
    gender() {
      if (['F', 'Female'].includes(this.customer.CustomerGender)) {
        return this.i18n.t('/Customer/Create New Customer Form/New Customer Gender Female')
      }
      if (['M', 'Male'].includes(this.customer.CustomerGender)) {
        return this.i18n.t('/Customer/Create New Customer Form/New Customer Gender Male')
      } else return this.i18n.t('/Customer/Create New Customer Form/New Customer Gender Other')
    },
    customerPhone() {
      const phoneFields = [
        'CustomerPhone',
        'CustomerPrivatePhone',
        'CustomerCellPhone',
        'CustomerCompanyPhone',
      ]

      for (const field of phoneFields) {
        if (this.customer[field]) {
          return this.customer[field]
        }
      }

      return '-'
    },
  },
}
</script>

<style lang="scss" scoped>
.customer-details {
  display: grid;
  grid-template-columns: 1fr 2fr;
  margin-bottom: 1em;
}
</style>
